import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import {Grid} from 'react-bootstrap';
import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import {Image, DetailInfoWrapper, DetailList} from '../components';
import doctor from 'images/general/doctor.svg';

import {loadInstitutionPersonalDetail} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  expertDetail: state.institutions.get('institutionPersonalDetail')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadInstitutionPersonalDetail(id))
});

class ExpertDetail extends Component {

  componentWillMount() {
    this.props.onLoad(this.props.match.params.expert_id)
  }

  render() {

    const item = this.props.expertDetail;

    if (this.props.expertDetail === undefined) {
      return null;
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
          <li><Link to="/health-management/experts">Позаштатні фахівці</Link></li>
          <li><Link to={`/health-management/experts/detail/${item.get('id')}`}>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')}</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
          <h2>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</h2>
          <DetailInfoWrapper>
            <Image>
            {item.get('user_data').get('photo') ? (
                              <img src={item.get('user_data').get('photo')} alt="Лікарі"/>
                              ):(
                              <img src={doctor} alt="Лікарі"/>
                            )}
            </Image>
            
            <DetailList>
              <li><span>Спеціальність: </span>{item.get('doctor_data').get('profession_classification_data').get('profession_title')}</li>
              <li><span>Місце роботи: </span>{item.get('comment')}</li>
              <li><span>Телефон: </span>{item.get('phone') ? item.get('phone') : "Телефон не вказано"}</li>
            </DetailList>
            </DetailInfoWrapper>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpertDetail);



// WEBPACK FOOTER //
// ./src/system/management/experts/detail.js